// ponytail: cross-field rule, same pattern as isConfirm.js (config carries the sibling field names to compare against).
// Card numbers are a 15-digit sequential payload + 1 Luhn check digit (16 digits total) - the
// check digit isn't a simple +1 increment, so it's stripped before counting the range.
const CARD_NUMBER_LENGTH = 16;
const DIGITS_ONLY = /^\d+$/;
const stripCheckDigit = (cardNumber) => cardNumber.slice(0, -1);

const isValidCardRange = (data) => {
  const end = data.value.trim();
  const config = data.config;
  const start = (data.allValues[config.startField] || "").toString().trim();
  const quantityRaw = (data.allValues[config.quantityField] || "")
    .toString()
    .trim();
  if (start === "" || end === "" || quantityRaw === "") return true; // isNotNull already flags missing fields

  if (start.length !== CARD_NUMBER_LENGTH || !DIGITS_ONLY.test(start))
    return `starting card # must be ${CARD_NUMBER_LENGTH} digits`;
  if (end.length !== CARD_NUMBER_LENGTH || !DIGITS_ONLY.test(end))
    return `must be ${CARD_NUMBER_LENGTH} digits`;

  const quantity = Number(quantityRaw);
  if (isNaN(quantity)) return "must be a number";

  const startNum = Number(stripCheckDigit(start));
  const endNum = Number(stripCheckDigit(end));
  const rangeSize = endNum - startNum + 1;
  return rangeSize === quantity
    ? true
    : `range must cover exactly ${quantity} card${quantity === 1 ? "" : "s"} (got ${rangeSize})`;
};

export default isValidCardRange;
